import { render, staticRenderFns } from "./RadioAddress.vue?vue&type=template&id=aa36436c&lang=pug&"
import script from "./RadioAddress.vue?vue&type=script&lang=js&"
export * from "./RadioAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports